import { baseApi, decodeProductExtensionEnvelope, resourceScopeTag, resourceTag, type ProductExtensionEnvelope } from '@krp/client-runtime'

import { normalizeRid } from '../../../shared/model/scopeKeys'
import { ONEC_PRODUCT_TAG } from '../../products/api/productsApi'
import { ONEC_PRODUCT_EXTENSION_URLS } from './urls'

/** Вид, который служба 1С пишет в `kind` конверта расширения. */
export const ONEC_EXTENSION_KIND = 'onec'

export interface OneCProductExtensionArgs {
  resourceId: string
  refKey: string
}

/**
 * Расширение карточки 1С в ОБЩЕМ `baseApi`. Тег карточки тот же, что у окна товара 1С: правка карточки в 1С перечитывает и
 * расширение. rid — аргумент запроса (часть ключа кэша) и часть тега.
 */
export const onecProductExtensionApi = baseApi.enhanceEndpoints({ addTagTypes: [ONEC_PRODUCT_TAG] }).injectEndpoints({
  endpoints: (build) => ({
    onecProductExtension: build.query<ProductExtensionEnvelope, OneCProductExtensionArgs>({
      query: ({ resourceId, refKey }) => ({
        url: ONEC_PRODUCT_EXTENSION_URLS.extension(resourceId, refKey),
        decode: decodeProductExtensionEnvelope(ONEC_EXTENSION_KIND),
      }),
      providesTags: (_result, _error, { resourceId, refKey }) => [
        resourceTag(ONEC_PRODUCT_TAG, normalizeRid(resourceId), refKey),
        resourceScopeTag(normalizeRid(resourceId)),
      ],
    }),
  }),
})

export const { onecProductExtension } = onecProductExtensionApi.endpoints
